// src/hooks/usePolling.js

import { useEffect, useRef } from 'react';

/**
 * Custom hook to poll a callback function at regular intervals
 * @param {Function} callback - Function to call on each interval
 * @param {number} interval - Polling interval in milliseconds
 * @param {boolean} enabled - Whether polling is enabled
 */
export const usePolling = (callback, interval = 30000, enabled = true) => {
  const savedCallback = useRef();
  
  // Remember the latest callback
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);
  
  // Set up the interval
  useEffect(() => {
    if (!enabled || !interval) {
      return;
    }
    
    const tick = () => {
      if (savedCallback.current) {
        savedCallback.current();
      }
    };
    
    const id = setInterval(tick, interval);
    
    return () => clearInterval(id);
  }, [interval, enabled]);
};

export default usePolling;

